import { ref } from 'vue'
import type { SectionMenuHeader } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/SectionMenu/composables/useSectionMenuScroll/types'

const HEADER_SELECTOR = '.the-header__sticky-line'
const PREVIEW_MENU_SELECTOR = '.preview-menu__bar'

function readPreviewMenuOffsetFromCss(): number {
  if (typeof document === 'undefined') {
    return 0
  }

  const cssOffset = getComputedStyle(document.documentElement)
    .getPropertyValue('--preview-menu-offset')
    .trim()

  if (!cssOffset.endsWith('px')) {
    return 0
  }

  return Number.parseFloat(cssOffset) || 0
}

/** Мобильная шапка + fixed PreviewMenu: видимый top-offset */
export default function createSectionMenuHeader(): SectionMenuHeader {
  const previewHeight = ref(readPreviewMenuOffsetFromCss())
  const headerOffset = ref(previewHeight.value)
  const headerHeight = ref(0)

  let headerEl: HTMLElement | null = null
  let observer: MutationObserver | null = null
  /** Снимок offset до смены class — в колбэке MutationObserver DOM уже новый */
  let lastOffset = 0

  function readMobileOffset() {
    if (!headerEl?.classList.contains('sticky') || headerEl.classList.contains('invisible')) {
      return 0
    }

    return headerHeight.value
  }

  function readPreviewHeight() {
    const previewEl = document.querySelector<HTMLElement>(PREVIEW_MENU_SELECTOR)

    if (previewEl?.offsetHeight) {
      return previewEl.offsetHeight
    }

    return readPreviewMenuOffsetFromCss()
  }

  function applyOffset() {
    previewHeight.value = readPreviewHeight()
    lastOffset = previewHeight.value + readMobileOffset()
    headerOffset.value = lastOffset
  }

  function refresh() {
    headerEl = document.querySelector<HTMLElement>(HEADER_SELECTOR)
    headerHeight.value = headerEl?.offsetHeight || 0
    applyOffset()
  }

  function onClassChange() {
    headerHeight.value = headerEl?.offsetHeight || 0
    previewHeight.value = readPreviewHeight()

    const nextOffset = previewHeight.value + readMobileOffset()

    headerOffset.value = nextOffset

    if (lastOffset === nextOffset) {
      return
    }

    lastOffset = nextOffset
  }

  function bind() {
    unbind()
    refresh()

    if (!headerEl) {
      return
    }

    observer = new MutationObserver(onClassChange)
    observer.observe(headerEl, {
      attributes: true,
      attributeFilter: ['class'],
    })
  }

  function unbind() {
    observer?.disconnect()
    observer = null
  }

  return {
    headerOffset,
    headerHeight,
    previewHeight,
    refresh,
    bind,
    unbind,
  }
}
